import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AdminMobileTopbar from "./AdminMobileTopbar";
import Button from "../../common/Button";
import success from "../../../assets/agent/success.svg";
import fail from "../../../assets/agent/fail.svg";
import { useAssignClient } from "./useAssignClient";

const MobileAssignClient = () => {
  const { t } = useTranslation();
  const { agents, clients, form, errors, successModal, setSuccessModal, errorModal, setErrorModal, handleChange, handleSubmit } =
    useAssignClient();

  return (
    <div className="flex flex-col h-screen bg-secondaryBg">
      <AdminMobileTopbar title={t("admin.assignClient", "Asignar cliente")} />

      <div className="flex-1 px-4 py-4">
        <div className="mb-3">
          <label className="block text-primary text-xs font-bold mb-1">{t("admin.option.selectClient")} *</label>
          <select
            value={form.clientId}
            onChange={(e) => handleChange("clientId", e.target.value)}
            className="w-full bg-white text-primary text-sm rounded-lg px-3 py-2.5 border border-gray-200"
          >
            <option value="">{t("button.selectOption")}</option>
            {clients.map((c) => (
              <option key={c.value} value={c.value}>{c.label}</option>
            ))}
          </select>
          {errors.clientId && <p className="text-red-500 text-[10px] mt-1">{errors.clientId}</p>}
        </div>

        <div className="mb-4">
          <label className="block text-primary text-xs font-bold mb-1">{t("admin.option.selectAgent")} *</label>
          <select
            value={form.agentId}
            onChange={(e) => handleChange("agentId", e.target.value)}
            className="w-full bg-white text-primary text-sm rounded-lg px-3 py-2.5 border border-gray-200"
          >
            <option value="">{t("button.selectOption")}</option>
            {agents.map((a) => (
              <option key={a.value} value={a.value}>{a.label}</option>
            ))}
          </select>
          {errors.agentId && <p className="text-red-500 text-[10px] mt-1">{errors.agentId}</p>}
        </div>

        <button
          type="button"
          onClick={handleSubmit}
          className="w-full bg-secondary text-white text-sm font-extrabold rounded-xl py-3"
        >
          {t("button.register")}
        </button>
      </div>

      {successModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
          <div className="bg-white rounded-2xl p-6 flex flex-col items-center text-center max-w-sm">
            <img src={success} alt="success" className="w-12 h-12 mb-3" />
            <p className="font-bold text-primary mb-4">{t("admin.userConfirm.head")}</p>
            <Link to="/dashboard">
              <Button variant="primary" onClick={() => setSuccessModal(false)}>{t("admin.userConfirm.btn")}</Button>
            </Link>
          </div>
        </div>
      )}
      {errorModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
          <div className="bg-white rounded-2xl p-6 flex flex-col items-center text-center max-w-sm">
            <img src={fail} alt="fail" className="w-12 h-12 mb-3" />
            <p className="font-bold text-primary mb-2">{t("admin.userError.head")}</p>
            {errors.submit && <p className="text-sm text-gray-500 mb-4">{errors.submit}</p>}
            <Button variant="secondary" onClick={() => setErrorModal(false)}>{t("admin.userError.btn")}</Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileAssignClient;
